<template>
  <!-- 头部 -->
  <el-row class="headerHtml">
    <el-col :span="5">
      <div style="display: flex;align-items: center;justify-content: flex-end;width: 100%;height: 100%;">
        <img src="../../assets/img/logo.png" style="width: 70%;margin-right: 20px;">
      </div>
    </el-col>
    <el-col class="headerCol" :span="3">
      <div class="headerLi headerHome" :class="{ 'active': route.name == 'index' }" @click="goHome()">
        <div class="imgIcon"></div>
        <span class="nameText">首页</span>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="headerLi headerZX" @click="GNJS()">
        <div class="imgIcon"></div>
        <span class="nameText">简介</span>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="headerLi headerZC" @click="jumpClick(2)">
        <div class="imgIcon"></div>
        <span class="nameText">首钢招标</span>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="headerLi headerBX" :class="{ 'active': route.name == 'shougangbixuan' }" @click="jumpClick(4)">
        <div class="imgIcon"></div>
        <span class="nameText">首钢比选</span>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="headerLi headerSC" @click="jumpClick(1)">
        <div class="imgIcon"></div>
        <span class="nameText">首钢商城</span>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="headerLi headerZC" @click="jumpClick(5)">
        <div class="imgIcon"></div>
        <span class="nameText">供应商自荐</span>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="headerLi headerDH" @click="jumpClick(3)">
        <div class="imgIcon"></div>
        <span class="nameText">联系我们</span>
      </div>
    </el-col>
    <!--<el-col :span="6" class="headerLogin">
      <span class="login">登录</span> 
    </el-col> -->
  </el-row>
</template>
<script>
import { useRoute, useRouter } from "vue-router";
</script>
<script setup>
const route = useRoute();
const router = useRouter();
const goHome = () => {
  router.push({
    path: "/index",
    query: {}
  })
}
//功能介绍
const GNJS = () => {
  // const File = new URL('@/assets/SGJTJCPT.jpeg', import.meta.url).href;
  // window.open(File)
  router.push({
        path:"/introduceText"
      })
  // const { href } = router.resolve({
  //   name: 'introduceText'
  // })
  // window.open(href, '_blank');

}
//跳转
const jumpClick = (key) => {
  // console.log(tabKey,key)
  if (key == 1) {
    // window.open("https://sgcgsc.obei.com.cn/");
    router.push({
        path:"/shoppingMallIndex"
      })
    // const { href } = router.resolve({
    //   name: 'shoppingMallIndex'
    // })
    // window.open(href, '_blank');

    

  } else if (key == 2) {
    // https://zb.sggylpt.com/
    // window.open("https://zb.sggylpt.com:2443/");
    window.open("https://zb.sggylpt.com");
  } else if (key == 3) {

    router.push({
        path:"/contactUs"
      })

    // const { href } = router.resolve({
    //   name: 'contactUs'
    // })
    // window.open(href, '_blank');
  } else if (key == 4) {
    
    router.push({
        path:"/shougangbixuan"
      })

    // const { href } = router.resolve({
    //   name: 'shougangbixuan'
    // })
    // window.open(href, '_blank');
    // window.open("https://www.sggylpt.com/static/purchaser/homePage/html-gulp-www/firstPages.html")
  } else if (key == 5) {
    window.open("https://www.sggylpt.com/static/purchaser/login/html-gulp-www/register.html");
  }
}
</script>

<style lang="scss" scoped>
.headerHtml {
  height: 100px;
  background-color: #fff;

  // background-color: #fff;
  // background-image: url("@/assets/img/logo.png");
  // background-size: 210px 49px;
  // background-repeat: no-repeat;
  // background-position: 9.78% 30px;
}

.headerCol {
  text-align: center;
}

.headerLi {

  height: 100px;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  cursor: pointer;
}

.headerLi .imgIcon {
  height: 24px;
  width: 24px;
}

.headerLi .nameText {
  font-weight: bold;
  font-size: 24px;
  color: #000;
  line-height: 36px;
  text-align: left;
  font-style: normal;
}

.headerLi .imgIcon {
  background-size: 100%;
  background-repeat: no-repeat;
  margin-right: 10px;
}

.headerHome .imgIcon {
  background-image: url("@/assets/img/home.png");
}

.headerZX .imgIcon {
  background-image: url("@/assets/img/zx.png");
}

.headerSC .imgIcon {
  background-image: url("@/assets/img/gwc.png");
}

.headerZC .imgIcon {
  background-image: url("@/assets/img/leixing.png");
}

.headerDH .imgIcon {
  background-image: url("@/assets/img/dh.png");
}

.headerBX .imgIcon {
  background-image: url("@/assets/img/bx.png");
}

.headerLi:hover {
  background: #0475D7;
}

.headerLi:hover .nameText {
  color: #FFFFFF;
}

.headerLi:hover {
  background: #0475D7;
}

.headerLi.headerHome:hover .imgIcon,
.headerLi.headerHome.active .imgIcon {
  background-image: url("@/assets/img/home1.png");
}

.headerLi.headerZX:hover .imgIcon {
  background-image: url("@/assets/img/zx1.png");
}

.headerLi.headerSC:hover .imgIcon {
  background-image: url("@/assets/img/gwc1.png");
}

.headerLi.headerZC:hover .imgIcon {
  background-image: url("@/assets/img/leixing1.png");
}

.headerLi.headerDH:hover .imgIcon {
  background-image: url("@/assets/img/dh1.png");
}

.headerLi.headerBX:hover .imgIcon,
.headerLi.headerBX.active .imgIcon {
  background-image: url("@/assets/img/bx1.png");
}

.headerLi.active {
  background: #0475D7;
}

.headerLi.active .nameText {
  color: #FFFFFF;
}

.headerLogin {

  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
}

.login {
  width: 72px;
  height: 32px;
  display: inline-block;
  color: #fff;
  background: #0475D7;
  font-size: 16px;
  line-height: 32px;
  cursor: pointer;
  text-align: center;
  font-weight: 500;
}

.headerHtml .el-col-3 {
  flex: 0 0 10.5%;
}

.headerLi .nameText {
  font-size: 22px;
}
</style>